export default __webpack_public_path__ + "static/media/F7AA3940-50EB-4692-88F9-253944D5D1E7_1_105_c.149f39c4.jpeg";